import { Component, ElementRef, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService, UserTypes } from 'src/app/Shared/Common/common.service';
import { UsersService } from 'src/app/Shared/Users/users.service';

declare var $: any;

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css']
})
export class LoginModalComponent implements OnInit {

  @Output() loginSuccess = new EventEmitter<any>();
  @Output() loginClose = new EventEmitter<any>();
  @ViewChild('termsCloseButton') termsCloseButton!: ElementRef<HTMLButtonElement>;
  private termsTrigger: HTMLElement | null = null;

  mobileNumber: string = '';
  otpCode: string = '';
  isModalVisible: boolean = false;
  isTermsModalVisible: boolean = false;
  termsAccepted: boolean = false;
  isLoader: boolean = false;

  // ✅ definite assignment assertion — initialized in ngOnInit
  userForm!: FormGroup;
  otpVerifyForm!: FormGroup;

  isOTPsent: boolean = false;
  userTypeID: number = 0;                 // ✅ initialized
  UserData: any[] = [];
  UserOTPData: number | undefined;        // ✅ allows undefined
  isUserExists: boolean = false;
  queryParams: any;
  searchParams: any;
  isLogin: boolean = false;
  redirectUrl: string = '';
  calltoActionData: string = '';
  otpInfoMessage: string = '';

  shareToken: string = '';


  constructor(
    private loginRouter: Router,
    private loginCommon: CommonService,
    private loginUsersService: UsersService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.userForm = this.fb.group({
      mobileNumber: ['', [
        Validators.required,
        Validators.pattern(/^\d{10}$/)
      ]]
    });

    this.otpVerifyForm = this.fb.group({
      otpCode: ['', [
        Validators.required,
        Validators.pattern(/^\d{6}$/)
      ]]
    });

    this.userTypeID = UserTypes.Visitor;
  }

  openModal() {
    this.isModalVisible = true;
    this.isLogin = true;
    this.shareToken = this.readShareTokenFromRoute();   // ✅
    this.resetForms();
  }

  openModalWithQueryParams(queryParams: any) {
    this.queryParams = queryParams;
    this.redirectUrl = queryParams?.redirectUrl || '';
    this.calltoActionData = queryParams?.calltoActionData || '';
    this.shareToken = queryParams?.shareToken
      || this.readShareTokenFromRoute();   // ✅
    this.isModalVisible = true;
    this.resetForms();
  }

  openModalWithSearchParams(queryParams: any) {
    if (queryParams?.redirectUrl.includes('viewproviders'))
      this.searchParams = queryParams?.params || {};
    else
      this.searchParams = JSON.parse(queryParams?.params) || {};
    this.redirectUrl = queryParams?.redirectUrl || '';
    this.calltoActionData = queryParams?.calltoActionData || '';
    this.shareToken = queryParams?.shareToken
      || this.readShareTokenFromRoute();   // ✅
    this.isModalVisible = true;
    this.resetForms();
  }


  private readShareTokenFromRoute(): string {
    try {
      const m = this.loginRouter.url.match(/\/share\/([A-Za-z0-9]+)/i);
      return m ? m[1] : '';
    } catch {
      return '';
    }
  }


  resetForms() {
    this.userForm.reset();
    this.otpVerifyForm.reset();
    this.termsAccepted = false;
    this.isOTPsent = false;
    this.isUserExists = false;
    this.mobileNumber = '';
    this.otpCode = '';
    this.otpInfoMessage = '';
  }

  closeModal(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isModalVisible = false;
    this.closeTermsModal(false);
    this.isLoader = false;
    this.isOTPsent = false;
    this.isUserExists = false;
    this.mobileNumber = '';
    this.otpCode = '';
    this.userForm.reset();
    this.otpVerifyForm.reset();
    this.termsAccepted = false;
    this.UserData = [];
    this.UserOTPData = undefined;
    this.queryParams = null;
    this.isLogin = false;
    this.otpInfoMessage = '';
    this.shareToken = '';   // ✅

    // Emit close event
    this.loginClose.emit({ closed: true });
  }

  openTermsModal(event: Event) {
    event.preventDefault();
    this.termsTrigger = event.currentTarget as HTMLElement;
    this.isTermsModalVisible = true;
    setTimeout(() => this.termsCloseButton.nativeElement.focus());
  }

  closeTermsModal(restoreFocus: boolean = true) {
    this.isTermsModalVisible = false;
    if (restoreFocus) {
      this.termsTrigger?.focus();
    }
    this.termsTrigger = null;
  }

  sendOTP() {
    if (this.userForm.invalid) {
      return;
    }

    this.mobileNumber = this.userForm.get('mobileNumber')?.value;
    this.isLoader = true;
    this.isUserExists = false;

    this.loginUsersService.CheckUserByMobile(this.mobileNumber).subscribe(
      res => {
        this.isLoader = false;

        if (res.status === 1) {
          this.UserData = res.body;

          if (this.UserData.length === 0) {
            this.isUserExists = false;
            $('#ConfirmModal').modal({
              backdrop: 'static',
              keyboard: false,
              show: true
            }).on('shown.bs.modal', () => {
              $('#ConfirmModal .modal-content').focus();
            });
          } else {
            this.isUserExists = true;
            this.SendOTPByMobile();
          }
        } else {
          this.loginCommon.CallToster('E', res.errorMessage);
        }
      },
      err => {
        this.isLoader = false;
        this.loginCommon.CallToster('E', 'Something went wrong while validating the mobile number. Please try again later.');
      }
    );
  }

  verifyOTP() {
    // ✅ require terms only on share pages
    if (this.otpVerifyForm.invalid) return;
    if (this.shareToken && !this.termsAccepted) return;

    this.otpCode = this.otpVerifyForm.get('otpCode')?.value;
    if (this.UserOTPData !== undefined && this.otpCode === this.UserOTPData.toString()) {
      if (!this.isUserExists) {
        this.doAddVisitors().then((res) => {
          this.handleLoginSuccess(res);
        }).catch((error) => {
          console.error("Error adding visitor:", error);
          this.loginCommon.CallToster('E', 'Error adding visitor. Please try again.');
        });
      } else {
        this.handleLoginSuccess();
      }
    } else {
      this.loginCommon.CallToster('E', 'Invalid OTP. Please try again.');
    }
  }

  handleLoginSuccess(res?: any) {
    return new Promise((resolve, reject) => {
      try {
        if (typeof res !== 'undefined' && res !== null && res.body && Array.isArray(res.body) && res.body.length > 0) {
          this.UserData = res.body;

          if (this.UserData[0] && this.UserData[0].USERID) {
            let userData = {
              UserID: this.UserData[0].USERID,
              UserName: this.UserData[0].USERID,
              UserType: this.userTypeID,
              IsVisitor: this.UserData[0].IsVisitor || false,
              IsAgent: this.UserData[0].IsAgent || false,
              IsBuilder: this.UserData[0].IsBuilder || false
            };

            this.doGetUserDetails(this.UserData[0].USERID, JSON.stringify(userData));

            if (this.queryParams != null || this.queryParams != undefined) {
              this.SendSerachDataToWhats();
              resolve(res);
            }

            // IMPORTANT: Emit event BEFORE closing modal
            console.log('Emitting login success event');
            this.loginSuccess.emit({ success: true, userData: this.UserData[0] });

            // Close modal after emitting
            this.closeModal();
          } else {
            this.loginCommon.CallToster('E', 'USERID is missing in the response. Please try again.');
            reject('USERID is missing');
          }
        } else if (this.UserData && Array.isArray(this.UserData) && this.UserData.length > 0) {
          if (this.UserData[0] && this.UserData[0].UserID) {
            let userData = {
              UserID: this.UserData[0].UserID,
              UserName: this.UserData[0].UserID,
              UserType: this.userTypeID,
              IsVisitor: this.UserData[0].IsVisitor || false,
              IsAgent: false,
              IsBuilder: false,
              IsProvider: false,
            };

            this.doGetUserDetails(this.UserData[0].UserID, JSON.stringify(userData));
            this.SendSerachDataToWhats();

            if (!this.isLogin && this.redirectUrl == '') {
              this.loginCommon.CallToster('S', 'Your Request sent to our Expert!');
            }

            // IMPORTANT: Emit event BEFORE closing modal
            console.log('Emitting login success event (fallback)');
            this.loginSuccess.emit({ success: true, userData: this.UserData[0] });

            // Close modal after emitting
            this.closeModal();
          } else {
            this.loginCommon.CallToster('E', 'USERID is missing in existing data. Please try again.');
            reject('USERID is missing in existing data');
          }
        } else {
          this.loginCommon.CallToster('E', 'User data is missing or USERID is not present. Please try again.');
          reject('UserData is missing or undefined');
        }
      } catch (error) {
        console.error('Error during login handling:', error);
        reject(error);
      }
    });
  }

  doGetUserDetails(userId: number, userLog: string) {
    try {
      this.isLoader = true;
      this.loginUsersService.GetUserProfile(userId, this.userTypeID).subscribe((res) => {
        if (res.status == 1) {
          var userData = res.body[0];
          localStorage.removeItem('authData');
          localStorage.removeItem('authProfileData');
          localStorage.removeItem('authExpiry');

          const expiryTime = new Date().getTime() + 60 * 60 * 1000;
          localStorage.setItem('authData', userLog);
          localStorage.setItem('authProfileData', JSON.stringify(userData));
          localStorage.setItem('authExpiry', expiryTime.toString());

          // Dispatch a custom event for localStorage change
          window.dispatchEvent(new Event('localStorageChange'));

          if (this.calltoActionData && this.calltoActionData != '') {
            let data = JSON.parse(this.calltoActionData);
            data.MobileNo = userData.Mobile;
            this.loginUsersService.StoreUserSearchHistory(data).subscribe(res => { }, err => { });
          }

          if (this.redirectUrl && this.redirectUrl != '') {
            const queryParams = this.searchParams;
            setTimeout(() => {
              this.loginRouter.navigate([this.redirectUrl], { queryParams }).then(() => {
                this.isLoader = false;
              });
            }, 1000);
          }
          this.isLoader = false;
        } else {
          this.isLoader = false;
          this.loginCommon.CallToster('E', 'Unable to authenticate your details. Please try again later');
        }
      }, err => {
        this.isLoader = false;
        this.loginCommon.CallToster('E', 'Unable to authenticate your details. Please try again later');
      });
    } catch (error) {
      this.isLoader = false;
      this.loginCommon.CallToster('E', 'Unable to authenticate your details. Please try again later');
    }
  }

  SendOTPByMobile() {
    try {
      setTimeout(() => {
        $('#ConfirmModal').modal('hide');
      }, 1000);

      this.isLoader = true;
      this.isOTPsent = true;
      this.termsAccepted = false;
      this.UserOTPData = Math.floor(100000 + Math.random() * 900000);
      this.SendOTPSMS();
      this.SendWhatsAppMsg(true);
      this.otpInfoMessage = `An OTP has been sent to ${this.userForm.get('mobileNumber')?.value}. Please check and enter it.`;
      setTimeout(() => {
        this.isLoader = false;
      }, 1000);
    } catch (error) {
      this.isLoader = false;
      this.loginCommon.CallToster('E', 'Unable to validate Mobile number, Please try again later...!');
    }
  }

  SendOTPSMS(isWatsapp: boolean = false, isForgot: boolean = false) {
    try {
      this.isLoader = true;

      if (isWatsapp === true) {
        this.SendWhatsAppMsg();
      }

      const Text =
        `${this.UserOTPData} is your verification OTP for Buyrentsale.com. ` +
        `Please do not share this code with anyone. - AINEXT IT`;

      this.loginCommon.SendSMS(
        Text,
        this.userForm.get('mobileNumber')?.value,
        this.UserOTPData?.toString(),          // ✅ server will store this
        this.shareToken || undefined          // ✅ null on non-share pages
      ).subscribe(
        res => {
          this.isLoader = false;
          // no UI change needed — SendOTPByMobile already set otpInfoMessage
        },
        err => {
          this.isLoader = false;
          // non-fatal: WhatsApp still goes out, OTP is still in memory
          console.error('SendSMS (OTP) failed:', err);
        }
      );
    } catch (error) {
      this.isLoader = false;
    }
  }

  SendWhatsAppMsg(isForgot: boolean = false) {
    try {
      let msg = '';
      msg = `${this.UserOTPData} is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. \n\nTeam,\nBuyrentsale.com\nMobile: 9618641100\nEmail: support@buyrentsale.com`;
      this.loginCommon.postMsgWithUrlToWhatsapp(this.userForm.get('mobileNumber')?.value, msg).subscribe(res => {
        this.isLoader = false;
      }, err => {
        this.isLoader = false;
        console.error('Error:', err);
      });
    } catch (error) {
      this.isLoader = false;
      console.error('Error:', error);
    }
  }

  doAddVisitors(): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const mobileNumberControl = this.userForm.get('mobileNumber');
        if (!mobileNumberControl) {
          throw new Error('MobileNumber form control is not found.');
        }

        let addUserModel = {
          UserBasicDetailsID: 0,
          UserID: 0,
          UserName: mobileNumberControl.value,
          Password: mobileNumberControl.value,
          UserTypeID: this.userTypeID,
          Phone: mobileNumberControl.value,
          Mobile: mobileNumberControl.value,
          EmailID: '',
        };
        this.isLoader = true;

        this.loginUsersService.SaveUserData(addUserModel).subscribe(
          (res) => {
            this.isLoader = false;
            if (res.status == 1 && Array.isArray(res.body) && res.body.length > 0 && res.body[0].USERID != 0) {
              this.loginCommon.DismissModel();
              this.SendWelcomeNoteWhats();
              resolve(res);
            } else {
              this.loginCommon.CallToster('E', 'There was an error while saving your details. Please try again later.');
              reject('Error: USERID is 0');
            }
          },
          (err) => {
            this.isLoader = false;
            this.loginCommon.CallToster('E', 'Something went wrong while registering your details. Please try again later');
            reject(err);
          }
        );
      } catch (error) {
        this.isLoader = false;
        this.loginCommon.CallToster('E', 'Unable to register your details. Please try again later.');
        reject(error);
      }
    });
  }

  SendWelcomeNoteWhats() {
    try {
      let msg = "Welcome to BuyRentSale.com, India's first real estate network and advertisement platform, "
      msg += "revolutionizing the property landscape by connecting buyers, sellers, agents, builders, and real estate business partners. "
      msg += "We provide a dynamic hub where property aspirations meet unparalleled opportunities. Join us to collectively fulfill everyone's dream of owning a property"
      msg += ".\n\n Experience BuyRentsale.com through this Product Demo Video Link : https://www.youtube.com/watch?v=adEo19mS2c4\n\nMore details and step-by-step guide on BuyRentsale.com "
      msg += "PDF Link : https://api.buyrentsale.com/uploads/defaults/buyrentsale.pdf \n\nTeam,\nBuyrentsale.com\nMobile:9618641100\nEmail: support@buyrentsale.com";

      this.loginCommon.postMsgWithUrlToWhatsapp(this.userForm.get('mobileNumber')?.value, msg).subscribe(res => {
        this.isLoader = false;
      }, err => {
        this.isLoader = false;
      });
    } catch (error) {
      this.isLoader = false;
    }
  }

  SendSerachDataToWhats() {
    try {
      const mobileVal = this.userForm.get('mobileNumber')?.value;
      if (!mobileVal) return;

      let msg = "Customer with Mobile No " + mobileVal + " is looking for Expert support from BuyRentSale with the below Search Data:\n";
      msg += `Property Type: ${this.queryParams.PropertyTypeName}\n`;
      msg += `Request Type: ${this.queryParams.ReqType}\n`;
      msg += `Budget: ${this.queryParams.Budget}\n`;
      msg += `Selected Areas: ${this.queryParams.SelectedAreaNames}\n`;

      this.loginCommon.postMsgWithUrlToWhatsapp(mobileVal, msg).subscribe(res => {
        this.isLoader = false;
      }, err => {
        this.isLoader = false;
      });
    } catch (error) {
      this.isLoader = false;
    }
  }

  navigateHome() {
    this.closeModal();
    this.loginRouter.navigateByUrl('/');
  }

  hideModal(event?: Event) {
    setTimeout(() => {
      $('#ConfirmModal').modal('hide');
    }, 1000);
  }
}